import CommentSection from 'app/components/layouts/Comments/CommentSection';
import QuestionList from 'app/components/tests/layouts/QuestionList';
import TaskButtons from 'app/components/tests/layouts/TaskButtons';
import * as categoryConst from 'app/constants/categories';
import { findTranslate } from 'app/utils/translate';
import { AppStoreState } from 'app/redux/store';
import { Passage, Question } from 'types/test';
import { useTranslation } from 'next-i18next';
import { toggleClass } from 'app/utils/dom';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { useState } from 'react';
import Link from 'next/link';

import dynamic from "next/dynamic";
const ModalExamScore = dynamic(() => import("app/components/tests/modal/ModalExamScore"), { ssr: false });

interface TestFooterProps {
  handleExamScore: () => void;
  activeQuestion: (question: Question) => void;
  numberQuestionDone: number;
  passagesOfUser: Passage[];
  initDataTest: () => void;
}

const TestFooter = (props: TestFooterProps) => {
  const { t } = useTranslation();
  const router = useRouter();
  const { test, process } = useSelector((state: AppStoreState) => state.test);
  const [openModal, setOpenModal] = useState(false);
  const isIeltRead = test.category_id == categoryConst.IELT_READ;
  const isIeltSpeak = test.category_id == categoryConst.IELT_SPEAK;

  return (
    <div className="footer-test">
      <div>
        {!isIeltSpeak &&
          <div className={`${!isIeltRead ? 'menu-test-mobile' : 'menu-test-ielt'}`}>
            <div className='menu-question pt-3'>
              <QuestionList
                passagesOfUser={props.passagesOfUser}
                numberQuestionDone={props.numberQuestionDone}
                handleExamScore={props.handleExamScore}
                activeQuestion={props.activeQuestion}
                initDataTest={props.initDataTest}
              />
              <button
                type="button"
                className="mt-3 mx-auto d-block btn btn-secondary"
                onClick={() => toggleClass('.menu-question', 'show-menu')}
              >
                {t('commons.close')}
              </button>
            </div>
            <div className="test-time-button">
              <img
                src="/images/commons/test_time.webp"
                alt="test-time"
                className="cursor-pointer btn-menu-test-mobile"
                onClick={() => toggleClass('.menu-question', 'show-menu')}
              />
            </div>
          </div>
        }
        <div className="mt-4">
          <TaskButtons />

          <button
            type="button"
            key={process}
            onClick={() => setOpenModal(true)}
            className={`${process == 'ready' ? 'd-flex' : 'd-none'} mx-auto mt-2 btn btn-outline-info`}
          >
            {t('tests.submit')}
          </button>
        </div>

        <ModalExamScore
          isOpen={openModal}
          onClose={() => setOpenModal(false)}
          handleExamScore={props.handleExamScore}
          key={props.numberQuestionDone}
          numberQuestionNotDone={test.questions_count - props.numberQuestionDone}
        />
      </div>
      {test?.grammar && (
        <div className="text">
          {t('tests.theory')}:
          <Link
            className="text-info p-1"
            href={`/grammar/${test?.grammar[`slug_${router?.locale}`]}`}
          >
            {findTranslate(test?.grammar?.translates, 'title', router?.locale)}
          </Link>
        </div>
      )}
      <CommentSection roomId={`test-id-${test?.id}`} />
    </div>
  )
}

export default TestFooter;
